import * as React from "react";
import {Component, Attributes} from "react";
import Tippy from "@tippy.js/react";

interface WidgetType {
    id: string;
    icon: string;
    defaultActionId: string;
    tooltip: string;
    suspendedTooltip?: string;
    suspended: boolean;
}

interface WidgetToolboxProps extends Attributes {
    widgetTypes: WidgetType[];
}

// noinspection JSUnusedGlobalSymbols
class WidgetToolboxComponent extends Component<WidgetToolboxProps> {
    render() {
        const {widgetTypes} = this.props;
        const widgetLinks = widgetTypes.map((widgetType) =>
            (
                <Tippy
                    key={widgetType.icon}
                    content={widgetType.suspended ? widgetType.suspendedTooltip :widgetType.tooltip}
                    theme={"dark"}
                    arrow={true}
                    placement={"bottom"}
                    arrowType={"sharp"}
                    size={"large"}
                >
                    <a
                       className={widgetType.suspended ? "widget-icon disabled" : "widget-icon"}
                       draggable={!widgetType.suspended}
                       data-suspended={widgetType.suspended ? "suspended" : null}
                       data-default-action-id={widgetType.defaultActionId}
                       data-icon={widgetType.icon}
                       data-widget-type={widgetType.id}
                    >
                        <div
                            className={`cursor-loading-widget type ${widgetType.icon}`}
                        />
                    </a>
                </Tippy>
            )
        );
        return (
            <div className="widget-toolbox-tooltip">
                {widgetLinks}
            </div>
        );
    }
}

// noinspection JSUnusedGlobalSymbols
export {
    WidgetToolboxComponent as default,
    WidgetToolboxComponent
};



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/toolbox/WidgetToolboxComponent.tsx